import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';

export const HouseContext = createContext();

const HouseProvider = ({ children }) => {
  const [houses, setHouses] = useState([]);
  const [filteredHouses, setFilteredHouses] = useState([]); 
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [city, setCity] = useState('City (any)');
  const [propertyType, setPropertyType] = useState('Property type (any)');
  const [priceRange, setPriceRange] = useState('Price range (any)');
  const [transactionType, setTransactionType] = useState('All'); 

  useEffect(() => {
    const fetchHouses = async () => {
      try {
        const response = await axios.get('http://navimumbaipropertylist.in/backend/api/property.php');
        setHouses(response.data);
        setFilteredHouses(response.data); 
        // console.log("Api response:", response.data);
        setLoading(false);
      } catch (error) {
        // console.error('Error fetching houses:', error);
        setError('Failed to load properties');
        setLoading(false);
      }
    };

    fetchHouses();
  }, []);

  const handleSearch = () => {
    let results = houses; 

   
    if (city !== 'City (any)') {
      results = results.filter(house => house.city === city);
    }

   
    if (propertyType !== 'Property type (any)') {
      results = results.filter(house => house.type === propertyType);
    }

  
    if (priceRange !== 'Price range (any)') {
      const [minPrice, maxPrice] = priceRange.split(' - ').map(price => parseInt(price));
      results = results.filter(house => house.price >= minPrice && house.price <= maxPrice);
    }

   
    if (transactionType !== 'All') {
      results = results.filter(house => house.listing_type === transactionType); 
    }

    setFilteredHouses(results); 
  };

  return (
    <HouseContext.Provider value={{ 
      houses, filteredHouses, 
      loading, 
      error, 
      city, 
      setCity, 
      propertyType, 
      setPropertyType, 
      priceRange, 
      setPriceRange, 
      transactionType, 
      setTransactionType, 
      handleSearch 
      
    }}>
      {children}
    </HouseContext.Provider>
  );
};

export default HouseProvider;
